export default {
    "confirm_modal": {
        "buttons": {
            "cancel": "Abbrechen",
            "confirm": "Bestätigen"
        }
    },
    "start": {
        "headline": "Willkommen bei OpenCal",
        "message": "Bitte verwenden Sie den persönlichen Link eines Nutzers, um Termine zu buchen."
    },
    "login": {
        "headline": "Bei OpenCal anmelden",
        "email": "E-Mail-Adresse",
        "password": "Passwort",
        "button": "Anmelden",
        "reset_password": "Passwort zurücksetzen",
        "welcome_message": "Willkommen zurück! Bitte geben Sie Ihre Daten ein.",
        "email_placeholder": "ihre{'@'}email.de",
        "password_placeholder": "••••••••",
        "otp": "Code aus der Authenticator-App",
        "otp_placeholder": "123456",
        "otp_hint": "Bitte geben Sie den sechsstelligen Code ein, den Ihre Authenticator-App gerade anzeigt.",
        "errors": {
            "invalid_credentials": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.",
            "two_factor_invalid": "Der Code stimmt nicht oder ist abgelaufen. Bitte geben Sie den aktuellen Code ein.",
            "network_error": "Ein Netzwerkfehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
            "unknown_error": "Ein unbekannter Fehler ist aufgetreten."
        }
    },
    "password_request": {
        "headline": "Passwort zurücksetzen",
        "email": "E-Mail-Adresse",
        "submit_button": "Passwort anfordern",
        "message_requested": "Falls ein Konto für diese E-Mail-Adresse existiert, erhalten Sie einen Link zum Zurücksetzen Ihres Passworts.",
        "welcome_message": "Geben Sie Ihre E-Mail ein, um einen Link zu erhalten."
    },
    "password_reset": {
        "headline": "Passwort zurücksetzen",
        "email": "E-Mail-Adresse",
        "password": "Neues Passwort",
        "password_repeat": "Passwort wiederholen",
        "submit_button": "Passwort zurücksetzen",
        "message_changed": "Das Passwort wurde erfolgreich zurückgesetzt.",
        "welcome_message": "Bitte geben Sie Ihr neues Passwort ein.",
        "errors": {
            "email_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            "password_dont_match": "Die Passwörter stimmen nicht überein."
        }
    },
    "header": {
        "nav": {
            "dashboard": "Übersicht",
            "appointments": "Termine",
            "logout": "Abmelden",
            "account": "Konto",
            "event_types": "Terminarten",
            "availability": "Verfügbarkeiten",
            "admin": "Administration"
        }
    },
    "account": {
        "headline": "Mein Konto",
        "name": "Name",
        "email": "E-Mail-Adresse",
        "locale": "Sprache",
        "password": "Passwort",
        "teams": "Teams",
        "buttons": {
            "edit": "Bearbeiten"
        },
        "messages": {
            "saved_success": "Änderungen erfolgreich gespeichert.",
            "save_failed": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
        },
        "form": {
            "title": "Kontodetails bearbeiten",
            "given_name": "Vorname",
            "family_name": "Nachname",
            "email": "E-Mail-Adresse",
            "locale": "Sprache",
            "buttons": {
                "cancel": "Abbrechen",
                "save": "Speichern"
            }
        },
        "caldav_accounts": "CalDAV-Konten",
        "caldav_auths": {
            "headline": "CalDAV-Konten",
            "buttons": {
                "edit": "Bearbeiten",
                "add": "Eintrag hinzufügen",
                "back": "Zurück",
                "log": "Protokoll"
            },
            "create_modal": {
                "headline": "CalDAV hinzufügen"
            },
            "form": {
                "buttons": {
                    "save": "Speichern"
                },
                "fields": {
                    "base_uri": "CalDAV-Kalender-URL",
                    "username": "Benutzername",
                    "password": "Passwort"
                },
                "success_message": "Der Eintrag wurde gespeichert."
            },
            "delete": {
                "confirm_headline": "CalDAV-Kalender-Zugang löschen?",
                "confirm_message": "Sind Sie sicher, dass Sie diesen Eintrag löschen möchten? Alle synchronisierten Daten werden entfernt.",
                "success_message": "Der Eintrag wurde gelöscht."
            },
            "logs": {
                "headline": "CalDAV Synchronisierung: Logs",
                "buttons": {
                    "back": "Back",
                },
                "item": {
                    "headline": "Sync-log details",
                    "table": {
                        "count_items": "Anzahl Datensätze",
                        "datetime": "Zeitpunkt",
                        "error_message": "Fehlermeldung",
                        "uri": "CalDAV URI",
                        "user": "CalDAV User",
                    }
                }
            }
        },
        "event_types": {
            "headline": "Terminarten",
            "delete": {
                "messages": {
                    "success": "Die Terminart wurde erfolgreich gelöscht."
                }
            },
            "form": {
                "fields": {
                    "name": "Name",
                    "slug": "Kurzname",
                    "location": "Ort",
                    "description": "Beschreibung",
                    "duration": "Dauer",
                    "minimum_notice": "Mindestvorlauf (Minuten)",
                    "booking_window": "Buchungshorizont (Tage)",
                    "buffer_before": "Puffer davor (Minuten)",
                    "buffer_after": "Puffer danach (Minuten)",
                    "max_bookings_per_day": "Höchstzahl Termine pro Tag",
                    "max_bookings_per_day_hint": "0 = unbegrenzt. Gezählt werden alle Termine des Tages, auch die anderer Terminarten.",
                    "languages": "Sprachen",
                    "default_language": "Standardsprache",
                    "allow_guests": "Weitere Gäste erlauben",
                    "sms_reminder": "SMS-Erinnerung anbieten (benötigt konfigurierten SMS-Webhook)",
                    "booking_fields": "Buchungsfragen",
                    "field_label": "Frage / Beschriftung",
                    "field_type": "Feldtyp",
                    "options": "Optionen (mit | trennen)",
                    "required": "Pflichtfeld",
                    "meeting_provider": "Meeting-Anbieter"
                },
                "messages": {
                    "success": "Die Terminart wurde erfolgreich gespeichert.",
                    "error": "Beim Speichern der Terminart ist ein Fehler aufgetreten.",
                    "location_required": "Der Ort ist für Vor-Ort-Termine erforderlich."
                    ,"language_required": "Mindestens eine Sprache muss aktiviert sein."
                },
                "buttons": {
                    "add_field": "Frage hinzufügen",
                    "remove_field": "Entfernen"
                }
            },
            "modal": {
                "headline": "Terminart"
            }
        },
        "availability": {
            "headline": "Verfügbarkeiten verwalten",
            "modal": {
                "headline": "Verfügbarkeit erstellen/bearbeiten"
            },
            "form": {
                "fields": {
                    "week_day": "Wochentag",
                    "start_time": "Startzeit",
                    "end_time": "Endzeit"
                },
                "buttons": {
                    "save": "Speichern"
                }
            },
            "buttons": {
                "add": "Eintrag hinzufügen"
            }
        }
    },
    "change": "ändern",
    "booking": {
        "index": {
            "intro": "Willkommen auf meiner Terminplanungsseite. Wähle eine Terminart, um einen Termin zu vereinbaren.",
            "intro_selected": "Wähle Tag und Uhrzeit für Deinen Termin.",
            "minutes": "Minuten",
            "event_type_not_found": "Diese Terminart gibt es nicht. Bitte wähle unten eine aus.",
            "select_event_type": "Womit kann ich Dir helfen?",
            "format_video": "Videoberatung",
            "event_type_label": "Terminart",
            "with": "mit",
            "duration_minutes": "{duration} Min.",
            "load_error": "Die Terminbuchung ist gerade nicht erreichbar. Bitte versuch es in ein paar Minuten noch einmal oder schreib mir an {email}.",
            "load_error_reload": "Neu laden",
            "no_event_types": "Unter dieser Adresse gibt es keine buchbaren Termine. Bitte prüfe den Link oder schreib mir an {email}."
        },
        "footer": {
            "source": "Quellcode (OpenCal)",
            "imprint": "Impressum",
            "privacy": "Datenschutz"
        },
        "book_now": {
            "not_available": "{name} ist am {date_string} nicht verfügbar. Bitte wähle einen anderen Tag.",
            "available_timeslots": "Verfügbare Zeiten",
            "select_time": "Wähle eine passende Uhrzeit",
            "timezone_notice": "Alle Uhrzeiten sind deutsche Zeit.",
            "load_failed": "Die freien Termine konnten nicht geladen werden. Bitte versuch es gleich noch einmal oder schreib mir an {email}.",
            "none_available": "In den nächsten {days} Tagen ist bei dieser Terminart leider nichts mehr frei. Schreib mir an {email}, dann finden wir einen Termin.",
            "timezone_differs": "Deine Zeitzone ({local}) unterscheidet sich um {offset}. Rechne das bitte mit ein.",
            "morning": "Vormittag",
            "afternoon": "Nachmittag"
        },
        "form": {
            "headline": "Termin buchen",
            "fields": {
                "name": "Name",
                "given_name": "Vorname",
                "family_name": "Nachname",
                "email": "E-Mail-Adresse",
                "phone": "Handynummer (optional)",
                "phone_hint": "Wenn Du sie angibst, erinnere ich Dich 24 Stunden vor dem Termin per SMS statt per E-Mail.",
                "sms_consent": "Ich möchte eine SMS-Erinnerung erhalten und willige in die Verarbeitung meiner Handynummer dafür ein.",
                "language": "Sprache für Bestätigung und Termin",
                "guests_add": "Weitere Person einladen",
                "guests": "Weitere Gäste (optional, höchstens zwei)",
                "guest_n": "E-Mail-Adresse weitere Person {n}",
                "guest_placeholder": "name{'@'}beispiel.de",
                "please_select": "Bitte auswählen",
                "confirm": "Ich willige ein",
                "location": "Wie möchtest Du teilnehmen?",
                "location_hint": "Den Link bekommst Du nach der Buchung per E-Mail.",
                "provider_help": "Erklärung zu {name}",
                "message": "Nachricht an {name} zur Vorbereitung auf den Termin",
                "name_placeholder": "Dein vollständiger Name",
                "email_placeholder": "deine{'@'}email.de",
                "message_placeholder": "Was sollte {name} vor dem Termin wissen?"
            },
            "summary": {
                "when": "Dein Termin",
                "where": "Zugang zum Videogespräch",
                "where_hint": "Denselben Link findest Du auch in der Bestätigungsmail und im Kalendereintrag.",
                "german_time": "deutsche Zeit"
            },
            "provider_info": {
                "jitsi_meet": "Öffnet sich im Browser, ein Konto brauchst Du nicht. Läuft auf meinem Server in Deutschland; Bild und Ton werden nicht aufgezeichnet.",
                "nextcloud_talk": "Du trittst über einen Link bei, ein Konto brauchst Du nicht. Der Server steht in Deutschland (Hetzner).",
                "google_meet": "Google-Dienst (USA). Ohne Google-Konto möglich: Namen eingeben und Teilnahme erbitten, ich lasse Dich herein."
            },
            "provider_short": {
                "jitsi_meet": "Im Browser, ohne Konto · Server in Deutschland",
                "nextcloud_talk": "Per Link, ohne Konto · Server in Deutschland",
                "google_meet": "Ohne Google-Konto möglich · Google-Dienst (USA)"
            },
            "required_legend": "Mit * markierte Felder musst Du ausfüllen.",
            "google_notice": "Deinen Termin trage ich in meinen Google-Kalender ein – mehr dazu in der {link}.",
            "google_notice_link": "Datenschutzerklärung",
            "buttons": {
                "submit": "Buchung bestätigen",
                "reschedule": "Termin umbuchen",
                "cancel": "Termin absagen"
            },
            "messages": {
                "success": "Dein Termin ist gebucht. Die Bestätigung mit dem Link kommt gleich per E-Mail – schau notfalls im Spam-Ordner nach.",
                "error": "Es ist ein Fehler aufgetreten. Bitte versuche es erneut."
            },
            "validation": {
                "location_required": "Bitte wähle aus, wie Du teilnehmen möchtest.",
                "required": "Bitte fülle dieses Pflichtfeld aus.",
                "email_invalid": "Bitte gib eine gültige E-Mail-Adresse ein.",
                "guests_too_many": "Bitte lade höchstens zwei weitere Personen ein. Für größere Runden schreib mir an {email}."
            },
            "your_details": "Deine Angaben"
        },
        "cancel": {
            "headline": "Termin absagen",
            "headline_done": "Termin abgesagt",
            "already_cancelled": "Dieser Termin ist bereits abgesagt.",
            "confirm_message": "Möchtest Du den Termin wirklich absagen?",
            "success_message": "Dein Termin ist abgesagt. Du bekommst gleich eine Bestätigung per E-Mail.",
            "book_again": "Neuen Termin buchen",
            "invalid": "Dieser Absagelink ist ungültig oder abgelaufen. Schreib mir bitte an {email}.",
            "error": "Die Absage hat nicht geklappt. Bitte versuch es noch einmal oder schreib mir.",
            "appointment": "Termin",
            "day": "Tag",
            "time": "Uhrzeit",
            "buttons": {
                "cancel_appointment": "Termin absagen"
            }
        },
        "reschedule": {
            "headline": "Termin umbuchen",
            "current": "Bisheriger Termin",
            "new_time": "Neuer Termin",
            "no_slots": "An diesem Tag ist keine passende Uhrzeit frei.",
            "submit": "Umbuchung verbindlich bestätigen",
            "success": "Dein Termin ist umgebucht. Du bekommst gleich eine aktualisierte Bestätigung per E-Mail.",
            "invalid": "Dieser Umbuchungslink ist ungültig oder abgelaufen. Schreib mir bitte an {email}.",
            "error": "Die Umbuchung hat nicht geklappt. Bitte versuch es noch einmal.",
            "slots_label": "Freie Uhrzeiten",
            "cancel_intro": "Du kannst den Termin gar nicht wahrnehmen?",
            "cancel_open": "Termin stattdessen absagen"
        }
    },
    "dashboard": {
        "admin": {
            "index": {
                "headline": "Administration"
            },
            "users": {
                "headline": "Benutzer",
                "buttons": {
                    "back": "Zurück",
                    "add": "Benutzer hinzufügen",
                },
                "modal": {
                    "headline": "Benutzer hinzufügen"
                },
                "form": {
                    "fields": {
                        "email": "E-Mail-Adresse",
                        "given_name": "Vorname",
                        "family_name": "Nachname"
                    },
                    "success_message": "Der Benutzer wurde erfolgreich erstellt."
                },
                "status": {
                    "enabled": "Aktiviert",
                    "disabled": "Deaktiviert",
                    "success_message": "Der Benutzerstatus wurde erfolgreich aktualisiert."
                },
                "delete": {
                    "confirm_headline": "Benutzer löschen?",
                    "confirm_message": "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
                    "success_message": "Der Benutzer wurde erfolgreich gelöscht.",
                    "buttons": {
                        "delete": "Benutzer löschen"
                    }
                },
                "roles": {
                    "admin": "Admin",
                    "user": "Benutzer"
                }
            },
            "audit_logs": {
                "headline": "Audit-Logs",
                "total": "Gesamt: {total}",
                "buttons": {
                    "back": "Zurück"
                },
                "table": {
                    "id": "ID",
                    "action": "Aktion",
                    "user": "Benutzer",
                    "data": "Daten",
                    "date": "Datum",
                    "no_logs": "Keine Logs gefunden."
                },
                "pagination": {
                    "previous": "Vorherige",
                    "next": "Nächste",
                    "page_info": "Seite {current}"
                }
            }
        },
        "appointments": {
            "index": {
                "headline": "Termine"
            },
            "details": {
                "headline": "Termindetails",
                "fields": {
                    "event_type": "Terminart",
                    "date_time": "Datum & Uhrzeit",
                    "participant_name": "Teilnehmer",
                    "participant_email": "E-Mail-Adresse",
                    "location": "Ort"
                }
            }
        }
    },
    "weekdays": {
        "monday": "Montag",
        "tuesday": "Dienstag",
        "wednesday": "Mittwoch",
        "thursday": "Donnerstag",
        "friday": "Freitag",
        "saturday": "Samstag",
        "sunday": "Sonntag"
    },
    "meeting_providers": {
        "jitsi_meet": "Jitsi Meet",
        "nextcloud_talk": "Nextcloud Talk",
        "google_meet": "Google Meet",
        "in_person": "Vor-Ort-Termin"
    }
};
